import { ReturnedDrugRegisterEntry } from './types/ReturnedDrugRegisterEntry';
import { useBooleanState, useWindowSize } from '@crx-dev/hss-react-infrastructure';
import React, { useMemo } from 'react';
import {
    ActionsLayout,
    Card,
    CardBody,
    CardDivider,
    CardFooter,
    CardLayout,
    CardSubtext,
    CardText,
    DateFormat,
    Button
} from '@crx-dev/hss-react-components';
import { Returned } from './types/EntryTypes/Returned';
import ReturnedInfo from './components/ReturnedInfo';
import { Destroyed } from './types/EntryTypes/Destroyed';
import DestroyedInfo from './components/DestroyedInfo';
import NoteForm from '../../Common/forms/NoteForm';

interface ReturnedEntriesListItemProps {
    item: ReturnedDrugRegisterEntry;
}

function ReturnedEntriesListItem({ item }: ReturnedEntriesListItemProps) {
    const [showingAddNoteForm, showAddNoteForm, hideAddNoteForm] = useBooleanState(false);
    const { width } = useWindowSize();

    const columns = useMemo(() => {
        if (width > 800) return 4;
        else return 2;
    }, [width]);

    return (
        <>
            <Card>
                <CardBody>
                    {item.returnedDrugRegisterEntryType === 'Returned' && (
                        <ReturnedInfo columns={columns} item={item as Returned} />
                    )}
                    {item.returnedDrugRegisterEntryType === 'Destroyed' && (
                        <DestroyedInfo columns={columns} item={item as Destroyed} />
                    )}
                    {item.notes && item.notes.length > 0 && (
                        <>
                            <CardDivider />

                            <CardLayout columns={1}>
                                {item.notes.map(note => (
                                    <Card key={note.id} nested background="BertYellow">
                                        <CardBody>
                                            <CardText mb="none">{note.note}</CardText>
                                            <CardSubtext>
                                                Added by {note.addedBy} at{' '}
                                                <DateFormat date={note.createdDateTime} inline />
                                            </CardSubtext>
                                        </CardBody>
                                    </Card>
                                ))}
                            </CardLayout>
                        </>
                    )}
                </CardBody>
                <CardFooter>
                    <ActionsLayout layout="end">
                        <Button id={`${item.id}-AddNote`} size="small" onClick={showAddNoteForm} variant="tertiary">
                            Add Note
                        </Button>
                    </ActionsLayout>
                </CardFooter>
            </Card>
            {showingAddNoteForm && (
                <NoteForm
                    registerId={item.returnedRegisterId}
                    entryId={item.id}
                    onCancel={hideAddNoteForm}
                    type="returneddrugregister"
                    queryKey="returned-entries"
                />
            )}
        </>
    );
}

export default ReturnedEntriesListItem;
